import { useEffect } from 'react';
const PIXEL_ID = '2364224690776967';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
    };
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.dataset.metaPixel = PIXEL_ID;
    document.head.appendChild(script);
    const queue: unknown[] = [];
    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        queue.push(args);
      }
    }) as NonNullable<Window['fbq']>;
    fbq.queue = queue;
    window.fbq = fbq;
    window._fbq = fbq;
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.alt = '';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return null;
}